import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import FormPageTemplate from '../templates/FormPageTemplate';
import LoginForm from '../molecules/LoginForm';
import { get, save, StorageKey } from '../services/client-storage';
import { useHistory } from 'react-router-dom';
export default function LoginPage () {
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const message = params.get('message');
  const applicationType = params.get('application');
  const isSSA = get(StorageKey.SSA_LOGIN_CHECKED);
  const [checked, setChecked] = React.useState( isSSA);
  const SSA_SOURCE = 'SSA';
  useEffect(() => {
    if (applicationType) {
      setChecked(applicationType?.toLowerCase() === SSA_SOURCE.toLowerCase())
    } else {
      setChecked(isSSA);
    }
  }, [applicationType, isSSA]);

  function handleChange(e: any) {
    save(StorageKey.SSA_LOGIN_CHECKED, JSON.stringify(e.target.checked))
    setChecked(e.target.checked);
    const newParams = new URLSearchParams(location.search);
    const message = newParams.get('message');
    if (!e.target.checked && message) {
      // need to clear message from params if user unchecks the box
      newParams.delete('message');
      history.push(`${location.pathname}?${newParams.toString()}`);
    }
  };

  return (
    <FormPageTemplate checked={checked}>
      <LoginForm message={message} applicationType={applicationType} checked={checked} handleChange={handleChange} />
    </FormPageTemplate>
  );
}
